import { render, staticRenderFns } from "./PH1Z.vue?vue&type=template&id=21ee88dd"
import script from "./PH1Z.vue?vue&type=script&lang=js"
export * from "./PH1Z.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports